// todo: ensure labels work correctly with no javascript
$(function () {
    initFloatLabels();

    document.addEventListener('myLLARegistrationStepSubmitted', function (e) {
        initFloatLabels();
    }, false);

    document.addEventListener('myLLAUpdateDetailsSubmitted', function (e) {
        initFloatLabels();
    }, false);
});

function initFloatLabels() {
    var $floatLabelInputs = $('.float-label input, .float-label select');
    setFloatLabels($floatLabelInputs);
    $floatLabelInputs.on('change keypress keydown keyup', function () {
        setFloatLabels($(this));
    });
}

function setFloatLabels($inputs) {
    $inputs.each(function () {
        var $input = $(this),
            $control = $input.closest('.form__control');
        if ($input.val() != '' && !$control.hasClass('float-label--active')) {
            $control.addClass('float-label--active');
        } else if ($input.val() == '' && $control.hasClass('float-label--active')) {
            $control.removeClass('float-label--active');
        }
    });
}